import { useEffect, useState } from 'react';
import { AiSuggestionComponent } from './components/ai-sugestion/ai-suggestion';
// import { CompanyInfoComponent } from './components/company-info';
import { ExportAnalyzeComponent } from './components/export-analyze';
import { ExportAnalyze } from './types';
import { Button } from '@leadsnavi/ui-kit';
import { CompanyRow } from '../type';
import { useDialogVisible } from '@/hooks/useDialogVisible';
import { CompanyInfoComponent } from './components/company-info';
import { useMount, useRequest } from 'ahooks';
import { getMergeCompanyList, getSupplierDetail } from '../services';
import { IApiEaseSourcingCompanyDetailResultVO } from '@/services/swagger/globalSearch/models';
import { IApiCompanyCountryVO } from '@/services/swagger/customs/models';
import { BaseDrawer } from '@/common/base/drawer';
import React from 'react';
import mixpanel from 'mixpanel-browser';

const BlockTitle = ({ title }: { title: string }) => (
  <h2 className="text-[color:var(--neutral-900,#171717)] [font-family:Geist] text-2xl font-semibold leading-[120%] tracking-[-0.48px]  mb-5">
    {title}
  </h2>
);

export const SupplierDetail: React.FC<{
  traceId?: string;
  companyDetail: IApiEaseSourcingCompanyDetailResultVO;
  companyRow?: CompanyRow | null;
  /** 优先使用此字段作为 AI 建议内容；未传时回退到 companyRow.detailedSellingPoint */
  detailedSellingPoint?: string[] | string;
  mergeCompanyResponse: IApiCompanyCountryVO[];
  isAiSummaryLoding: boolean;
}> = props => {
  const { traceId, companyDetail, companyRow, detailedSellingPoint, mergeCompanyResponse, isAiSummaryLoding } = props;

  const resolvedSellingPoint = detailedSellingPoint ?? companyRow?.detailedSellingPoint;
  const aiSuggestionContent = Array.isArray(resolvedSellingPoint)
    ? resolvedSellingPoint.join('; ')
    : (resolvedSellingPoint ?? '');

  const [exportAnalyze] = useState<ExportAnalyze>({
    activeTab: 'overview',
  });

  return (
    <div className="w-full max-w-5xl mx-auto  space-y-8 pb-4" id={traceId}>
      {/* 左侧内容：AI建议和公司信息 */}
      <div className="space-y-6">
        {/* AI建议 */}
        {!isAiSummaryLoding && !aiSuggestionContent ? null : (
          <AiSuggestionComponent loading={isAiSummaryLoding} content={aiSuggestionContent} />
        )}

        {/* 公司信息 */}
        {companyDetail && <CompanyInfoComponent info={companyDetail} />}
      </div>

      {/* 右侧内容：导出分析 */}
      {companyDetail && mergeCompanyResponse && mergeCompanyResponse.length ? (
        <div>
          <BlockTitle title="Export Analyze" />
          <ExportAnalyzeComponent
            initialState={exportAnalyze}
            mergeCompanyResponse={mergeCompanyResponse}
            companyDetail={companyDetail}
          />
        </div>
      ) : null}
    </div>
  );
};

interface SupplierDetailDrawerProps {
  traceId?: string;
  visible: boolean;
  supplier: CompanyRow | null;
  companyId?: string;
  onClose: () => void;
  isAiSummaryLoding: boolean;
  /** 优先使用此字段作为 AI 建议内容；未传时回退到 supplier.detailedSellingPoint */
  detailedSellingPoint?: string[] | string;
}

export const BaseSupplierDetailDrawer: React.FC<SupplierDetailDrawerProps> = props => {
  const { visible, onClose, companyId, traceId } = props;
  const { data, run: runGetSupplierDetail } = useRequest(
    async (companyId: string) => {
      if (!companyId) return Promise.resolve(undefined);
      const res = await getSupplierDetail({ companyId });
      const companyDetail = res.data;
      const mergeCompanyResponse = await getMergeCompanyList({
        id: companyDetail?.id,
      }).catch(() => undefined);

      return {
        companyDetail: res.data,
        mergeCompanyResponse: mergeCompanyResponse?.data || [],
      };
    },
    {
      manual: true,
    }
  );
  useMount(() => {
    if (traceId) {
      mixpanel.track(traceId);
    }
  });
  const companyDetail = data?.companyDetail;
  const open = useDialogVisible(visible);
  useEffect(() => {
    if (!open || !companyId) return;
    runGetSupplierDetail(companyId);
  }, [runGetSupplierDetail, open, companyId]);

  if (!open) {
    return null;
  }

  return (
    <BaseDrawer title={companyDetail?.name} open={visible} onOpenChange={() => onClose()}>
      {companyDetail && data.mergeCompanyResponse ? (
        <SupplierDetail
          traceId={traceId}
          isAiSummaryLoding={props.isAiSummaryLoding}
          companyRow={props.supplier}
          detailedSellingPoint={props.detailedSellingPoint}
          companyDetail={companyDetail}
          mergeCompanyResponse={data?.mergeCompanyResponse}
        />
      ) : null}
    </BaseDrawer>
  );
};

/**
 * 包装一层，减少重复渲染
 * @param props
 * @returns
 */
export const SupplierDetailDrawer: React.FC<SupplierDetailDrawerProps> = props => {
  const open = useDialogVisible(props.visible);
  if (!open) {
    return null;
  }
  return <BaseSupplierDetailDrawer {...props} />;
};

export const TestSupplierDetailDrawer = (props: { companyId: string; description?: string }) => {
  const [isSupplierDetailDrawerVisible, setIsSupplierDetailDrawerVisible] = useState(false);
  const { companyId, description } = props;
  return (
    <div className=" p-4 border border-amber-500">
      <p>{description}</p>
      <p>companyId: {companyId}</p>
      <Button
        onClick={() => {
          setIsSupplierDetailDrawerVisible(true);
        }}
      >
        打开供应商详情弹窗
      </Button>
      <BaseSupplierDetailDrawer
        supplier={
          {
            id: companyId,
            name: 'Test Supplier',
            detailedSellingPoint: ['Test Selling Point'],
          } as unknown as CompanyRow
        }
        isAiSummaryLoding={false}
        visible={isSupplierDetailDrawerVisible}
        onClose={() => {
          setIsSupplierDetailDrawerVisible(false);
        }}
        companyId={companyId}
      />
    </div>
  );
};
